<script>
import options from './SimpleCard.options'
export default options
</script>

<template>
  <component :is="hasLink ? 'a' : 'div'" v-bind="hasLink ? { href: result.url, target: result.urlTarget } : {}"
    class="kb-simple-card" :class="{ 'kb-simple-card--no-link': !hasLink }">
    <template v-if="result.imageUrl">
      <img :src="result.imageUrl" :alt="result.altText" class="kb-simple-card__image" />
    </template>

    <h3 class="kb-simple-card__title" v-html="result.title"></h3>

    <p class="kb-simple-card__text">{{ result.summary }}</p>

    <div :class="{
      'kb-simple-card__link-icon': isInternalLink,
      'kb-simple-card__link-icon kb-simple-card__link-icon--external': !isInternalLink
    }" v-if="hasLink">
      <template v-if="!isInternalLink">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
          <path fill="#3C3C3C" fill-rule="evenodd"
            d="m12.978 2.708-3.864-.191-.049-.987 4.37.217c.279.014.516.246.53.518l.216 4.37-1.011-.05-.192-3.877Zm-8.924 8.23 6.734-6.734.707.707-6.734 6.734-.707-.707ZM1.5 3H1v12h12V8.312h-1V14H2V4h5.688V3H1.5Z"
            clip-rule="evenodd" />
        </svg>
      </template>
      <template v-else>
        <svg viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m15.208 1 4.528 5-4.528 5" stroke="#E8001D" stroke-linejoin="round" />
          <path d="M14.683 6H0" stroke="#E8001D" />
        </svg>
      </template>
    </div>
  </component>
</template>
